import React from "react";

export default function BillNumberOfPersons(props) {
  return (
    <div>
      <h3 className="label">Number of People</h3>
      <div className="bill-input-container ">
        <input
          onChange={(e) => props.onSelectNumOfPeople(e.target.value)}
          className="bill-input"
          type="number"
          min="1"
          value={props.numberOfPeople}
        />
      </div>
    </div>
  );
}
